import { FrequencySelector } from 'components/atoms/selects/FrequencySelector'
import { TagSelector } from 'components/atoms/selects/TagSelector'
import { dateToString } from 'utils/dateToString'
import { BooleanSelector } from 'components/atoms/selects/BooleanSelector'
import { InputText } from 'components/atoms/inputs/InputText'
import { InputDate } from 'components/atoms/inputs/InputDate'
import { InputValue } from 'components/atoms/inputs/InputValue'
import { DisplayText } from 'components/atoms/inputs/DisplayText'
import { useFormContext } from 'react-hook-form'

type Props = {
  updateAt?: string
}
export const CompanyDetail = (props: Props): JSX.Element => {
  const { updateAt } = props
  const isNew = !updateAt
  const { watch, setValue } = useFormContext()
  const focusCustomer = watch('focusCustomer')

  return (
    <div>
      <div className={'mb-3 flex gap-3'}>
        <div className={'flex-1'}>
          <InputText label={'会社名'} name={'name'} required />
        </div>
        <button
          type={'button'}
          onClick={() => setValue('focusCustomer', !focusCustomer)}
          className="flex items-center gap-2 self-end px-3 py-2 text-sm font-medium text-[#555] transition-colors"
        >
          <span
            className={[
              'relative inline-flex h-5 w-10 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200',
              focusCustomer ? 'bg-[#01695C]' : 'bg-gray-300'
            ].join(' ')}
          >
            <span
              className={[
                'pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow transition duration-200',
                focusCustomer ? 'translate-x-5' : 'translate-x-0',
                !focusCustomer && 'bg-gray-500'
              ]
                .filter(Boolean)
                .join(' ')}
            />
          </span>
          注力顧客
        </button>
      </div>
      <div className={'grid grid-cols-2 gap-3'}>
        <div>
          <DisplayText value={dateToString(updateAt ?? '')} label={'発起'} />
        </div>
        <div>
          <FrequencySelector
            label={'訪問頻度'}
            name={'frequencyCode'}
            required={!isNew}
          />
        </div>
        <div>
          <TagSelector label={'配信タグ'} name={'tagCode'} required={!isNew} />
        </div>
        <div>
          <InputText name={'specialty'} label={'得意分野'} required={!isNew} />
        </div>
        <div>
          <InputText
            name={'specialtyIndustry'}
            label={'得意業種'}
            required={!isNew}
          />
        </div>
        <div>
          <InputText
            name={'postCode'}
            label={'郵便番号'}
            required={!isNew}
            discription={'ハイフンなしで入力してください。'}
          />
        </div>
        <div>
          <InputText name={'address'} label={'住所'} required={!isNew} />
        </div>
        <div>
          <InputText
            name={'homePhone'}
            label={'固定番号'}
            required={!isNew}
            discription={'ハイフンなしで入力してください。'}
          />
        </div>
        <div>
          <InputText
            name={'homepage'}
            label={'ホームページ'}
            required={!isNew}
          />
        </div>
        <div>
          <InputDate
            name={'establishment'}
            label={'設立年月日'}
            required={!isNew}
          />
        </div>
        <div>
          <InputText
            name={'invoice'}
            label={'インボイス'}
            required={!isNew}
            discription={'Tから始まる13桁の文字列で入力してください。'}
          />
        </div>
        <div>
          <InputValue
            name={'salesValue'}
            label={'営業人数'}
            required={!isNew}
          />
        </div>
        <div>
          <InputValue
            name={'properValue'}
            label={'プロパー数'}
            required={!isNew}
          />
        </div>
        <div>
          <InputValue name={'bpValue'} label={'BP数'} required={!isNew} />
        </div>
        <div>
          <InputText
            name={'deliverAddress'}
            label={'配信アドレス'}
            required={!isNew}
          />
        </div>
        <div>
          <BooleanSelector
            name={'dispatchLicense'}
            label={'派遣免許有無'}
            required={!isNew}
          />
        </div>
        <div>
          <InputText
            name={'dispatchLicenseNumber'}
            label={'派遣免許番号'}
            required={!isNew}
            discription={'「派XX-XXXXXX」の形式で入力してください。'}
          />
        </div>
        <div>
          <BooleanSelector label={'Pマーク'} name={'pMark'} required={!isNew} />
        </div>
        <div>
          <BooleanSelector label={'ISMS'} name={'isms'} required={!isNew} />
        </div>
      </div>
    </div>
  )
}
